import React, { memo, useMemo } from "react";
import styled from "styled-components";
import { theme } from "uikit";

import { Executor } from "../../../../../../../../../../services";
import { ReceiptBindingTarget } from "../../../../../../../../../../services/ReceiptProvider/types";
import { useTypedSelector } from "../../../../../../../../../../redux/store";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";
import { DisabledCheckbox } from "../../../../../../../../../../components";
import { resolveReceiptColumnInfo } from "../../../../../../../../../../utils/receiptColumn.util";

/**
 * Заливка на всю ячейку: `.rs-table-cell` позиционирована абсолютно, а
 * внутренний блок имеет отступы, поэтому фон у самого контента красит только
 * область под текстом. Абсолютный слой с нулевыми отступами перекрывает ячейку целиком.
 */
const Fill = styled.div<{ $color?: string }>`
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	display: flex;
	align-items: center;
	background-color: ${({ $color }) => $color ?? "transparent"};
`;

const Name = styled.span`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const ElectronicReceiptsCellContent: React.FC<ElectronicReceiptsCellContent.Props> =
	memo(({ item }) => {
		const providers = useTypedSelector(
			(state) => state.settingsReceiptProvider.data,
		);

		const info = useMemo(
			() =>
				resolveReceiptColumnInfo(
					providers,
					item.taxiService?.id,
					ReceiptBindingTarget.EXECUTOR,
					item.useElectronicReceipts,
					item.id,
				),
			[
				providers,
				item.taxiService?.id,
				item.useElectronicReceipts,
				item.id,
			],
		);

		// Фон: зелёный — есть привязанная активная касса, красный — нет.
		const backgroundColor = info.fill
			? `${theme.colors[info.fill]}40`
			: undefined;

		return (
			<Fill $color={backgroundColor}>
				<CellContentRoot
					alignItems="center"
					w="100%"
					h="100%"
					gap="6px"
				>
					<DisabledCheckbox value={info.enabled} />
					{info.enabled ? (
						<Name title={info.providerNames}>
							{info.providerNames}
						</Name>
					) : null}
				</CellContentRoot>
			</Fill>
		);
	});

declare namespace ElectronicReceiptsCellContent {
	interface Props {
		item: Executor.Model;
	}
}

export default ElectronicReceiptsCellContent;
